const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410308104',
            ext_path: '河南省 洛阳市 孟津区 白鹤镇',
            cid: '1',
            pid: '410308',
            name: '白鹤镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.497307, 34.870507]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308109',
            ext_path: '河南省 洛阳市 孟津区 常袋镇',
            cid: '2',
            pid: '410308',
            name: '常袋镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.361383, 34.790545]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308105',
            ext_path: '河南省 洛阳市 孟津区 朝阳镇',
            cid: '3',
            pid: '410308',
            name: '朝阳镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.465662, 34.770474]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308100',
            ext_path: '河南省 洛阳市 孟津区 城关镇',
            cid: '4',
            pid: '410308',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.441224, 34.829394]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308108',
            ext_path: '河南省 洛阳市 孟津区 横水镇',
            cid: '6',
            pid: '410308',
            name: '横水镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.284421, 34.868073]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308101',
            ext_path: '河南省 洛阳市 孟津区 会盟镇',
            cid: '7',
            pid: '410308',
            name: '会盟镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.690391, 34.814437]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308107',
            ext_path: '河南省 洛阳市 孟津区 麻屯镇',
            cid: '9',
            pid: '410308',
            name: '麻屯镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.333875, 34.753403]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308102',
            ext_path: '河南省 洛阳市 孟津区 平乐镇',
            cid: '10',
            pid: '410308',
            name: '平乐镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.608435, 34.761044]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308103',
            ext_path: '河南省 洛阳市 孟津区 送庄镇',
            cid: '11',
            pid: '410308',
            name: '送庄镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.550847, 34.787252]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308106',
            ext_path: '河南省 洛阳市 孟津区 小浪底镇',
            cid: '12',
            pid: '410308',
            name: '小浪底镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.333474, 34.89191]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308401',
            ext_path: '河南省 洛阳市 孟津区 大庆路街道',
            cid: '401',
            pid: '410308',
            name: '大庆路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.599274, 34.901955]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410308004',
            ext_path: '河南省 洛阳市 孟津区 吉利街道',
            cid: '402',
            pid: '410308',
            name: '吉利街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.583228, 34.899012]
        }
    }
];

export { d };
